import { frontendURL } from '../../../../helper/URLHelper';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/tickets'),
      component: Index,
      name: 'settings_tickets_index',
      meta: {
        permissions: ['administrator'],
        module: 'tickets',
      },
    },
  ],
};
